export const sortDailyThumbValues = ["作成日", "更新日"] as const;
export type SortDailyThumbType = typeof sortDailyThumbValues[number];

export const isSortDailyThumbType = (
  sortType: string
): sortType is SortDailyThumbType => {
  return sortDailyThumbValues.some((value) => value === sortType);
};
